import { useRef, useEffect, useState } from "react";

interface ScaledImageProps { 
    src: string, 
    scale: number;
    alt: string;
}

const ScaledImage = (props: ScaledImageProps) => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const img = imgRef.current;

        const handleLoad = () => {
            let naturalWidth = img?.naturalWidth;
            let naturalHeight = img?.naturalHeight;
            if (naturalHeight && naturalWidth) {
                setSize({
                    width: naturalWidth * props.scale,
                    height: naturalHeight * props.scale,
                });
            }
        };

        if (img && img.complete) {
            handleLoad();
        } else if (img) {
            img.addEventListener("load", handleLoad);
            return () => img.removeEventListener("load", handleLoad);
        }
    }, [props.scale, props.src]);

    return (
        <img
            ref={imgRef}
            src={props.src}
            alt={props.alt}
            width={size.width}
            height={size.height}
            style={{ display: size.width ? "block" : "none" }}
        />
    );
};

export default ScaledImage;
